module.exports = __webpack_public_path__ + "static/media/program2.d99355dd.jpg";